import { render, staticRenderFns } from "./paramount-layout.vue?vue&type=template&id=737779e8&"
import script from "./paramount-layout.vue?vue&type=script&lang=ts&"
export * from "./paramount-layout.vue?vue&type=script&lang=ts&"
import style0 from "./paramount-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports